var DOMfunction = function () {


  function removeVideo () {
    $('.modal-content iframe.youtube-video').each(function() {
        var src = $(this).attr('src');
        $(this).attr('src', src);
    });
  }

  // Open video
  $('.js-open-modal').click(function (e) {
    e.preventDefault();
    $('.modal-content').addClass('active');
  });
  $('.js-open-content-modal').click(function (e) {
    e.preventDefault();
    removeVideo();
    var src = $(this).attr('href');
    $('.modal-content iframe').attr('src', src);
    $('.modal-content').addClass('active');
  });
  $('.js-close-modal').click(function () {
    $('.modal-content').removeClass('active');
    removeVideo();
  });

  if($('.js-overview-block').length > 0) {
    $('.js-overview-block').appendTo('.product-section-info');
  }

  $('.js-open-accordeon').click(function () {
    let $this = $(this);
    $this.toggleClass('active');
    $this.next('.product-section-accordeon__text').stop().slideToggle();
  });

  // Product section  info

  if($('.product-section-info__element').length > 0) {
    $('.product-section-info__element').each(function(index) {
      var originalInfo = $(this).data('info');
      var info = originalInfo.toLowerCase().replace(/\s+/g, '-'); // Reemplazar espacios con guiones y convertir a minúsculas
      var listItem = $('<li></li>');
      var button = $('<button id="' + info + '">' + originalInfo + '</button>'); // Usar el texto original para el botón
    
      button.on('click', function() {
        $('.product-section-info__element').hide();
        $('.product-section-info__element[data-info="' + originalInfo + '"]').show(); // Usar el texto original para la búsqueda
        $('ul .active').removeClass('active');
        $(this).addClass('active');
        if($("#product-info").length > 0) {
          $('html, body').animate({
            scrollTop: $("#product-info").offset().top - 40
          }, 500);
        }
       
      });
    
      listItem.append(button);
      $('.product-info-elements ul').append(listItem);
    
      if (index === 0) {
        $(this).show();
        listItem.find('button').addClass('active');
      } else {
        $(this).hide();
      }
    });
  }
 

  // Sticky scroll
  if($('.product-info-elements').length > 0) {
    $(window).scroll(function() {
      var scrollPosition = $(this).scrollTop();
      var productInfoElementsOffsetTop = $('.product-info-elements').offset().top;
      
      if (scrollPosition >= productInfoElementsOffsetTop) {
        $('.product-info-elements').addClass('fixed');
      } else {
        $('.product-info-elements').removeClass('fixed');
      }
    });
  }
  
  

  // Slider widget
  $('.js-slider-widget').slick({
    dots: false,
    loop: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="material-icons-outlined">arrow_back_ios</span></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="material-icons-outlined">arrow_forward_ios</span></button>',
  })

  // Empty
  var $container = $('.container-product-info');
  var $ul = $container.find('ul');

  // Verificar si la ul está vacía
  if ($ul.children().length === 0) {
    // La ul está vacía, añadir la clase 'empty' al contenedor
    $container.addClass('empty');
  }

  // Call size
  $('.table-row-item').each(function() {
    // Obtener todas las columnas en esta fila
    var columns = $(this).find('.table-compare__col.col');
  
    // Inicializar un array para almacenar alturas máximas por posición
    var maxHeights = [];
  
    // Iterar a través de las columnas
    columns.each(function() {
      var elements = $(this).find('.table-compare--item:not(.table-compare__subtitle).table-compare__element');
  
      // Iterar a través de los elementos en esta columna
      elements.each(function(index) {
        var elementHeight = $(this).outerHeight() ;
  
        // Inicializar la altura máxima para esta posición si aún no existe
        if (!maxHeights[index]) {
          maxHeights[index] = 0;
        }
  
        // Actualizar la altura máxima para esta posición si es necesario
        if (elementHeight > maxHeights[index]) {
          maxHeights[index] = elementHeight + 60;
        }
      });
    });
  
    // Aplicar las alturas máximas a los elementos de todas las columnas en la misma posición
    columns.each(function() {
      var elements = $(this).find('.table-compare--item:not(.table-compare__subtitle).table-compare__element');
  
      elements.each(function(index) {
        $(this).css('height', maxHeights[index] + 'px');
      });
    });
  });

  // FAQ Link click
  if(window.location.href.indexOf('faq=flow-pro1') !== -1){
    $('#flowanalyser-pro').click();
  }
  if(window.location.href.indexOf('faq=flow-pf') !== -1){
    $('#flowanalyser-pf-300').click();
  }
  if(window.location.href.indexOf('faq=citrex-h5') !== -1){
    $('#citrex-h5').click();
  }
  if(window.location.href.indexOf('faq=citrex-h4') !== -1){
    $('#citrex-h4').click();
  }
  if(window.location.href.indexOf('faq=citrex-h3') !== -1){
    $('#citrex-h3').click();
  }
  if(window.location.href.indexOf('faq=testlungs') !== -1){
    $('#testlungs').click();
  }
  
  // Theme skin
  if($('#disable-white-skin').val() != 'true'){
    if($('#theme-skin-light').length > 0){
      $('body').addClass('theme-skin-light');
    }
    // Primero verificamos si la URL es /blogs/news o /es/blogs/noticias/ o cualquier idioma/blogs/news
    if (/^\/blogs\/news/.test(window.location.pathname) || 
        /^\/es\/blogs\/noticias\//.test(window.location.pathname) ||
        /^\/(?:es|fr|de|zh|ja)\/blogs\/news/.test(window.location.pathname)) {
      // Si es /blogs/news o /es/blogs/noticias/ o cualquier idioma/blogs/news, NO aplicamos theme-skin-light
      $('body').removeClass('theme-skin-light');
    } else if (
      window.location.pathname.indexOf('/flow-meters') !== -1 ||
      window.location.pathname.indexOf('/compare-flow-meters') !== -1 ||
      window.location.pathname.indexOf('/biomedical-blog') !== -1 ||
      /^\/(?:es|fr|de|zh|ja)\/blogs(?!\/noticias)/.test(window.location.pathname) ||
      /^\/blogs(?!\/news)/.test(window.location.pathname) ||
      /^\/blogs(?!\/noticias)/.test(window.location.pathname)
    ) {
      // Si no es /blogs/news ni /es/blogs/noticias/ ni cualquier idioma/blogs/news y cumple alguna de estas condiciones, aplicamos theme-skin-light
      $('body').addClass('theme-skin-light');
    }
  }
  

  if (
    window.location.pathname.indexOf('/blogs/news/') !== -1
   
  ) { 
    $('.js-url').attr('href', '/blogs/news');
  }
 

  
 

  if(window.location.pathname.indexOf('/blogs/alveo-lung-simulator-news/') !== -1){
    // Verificar si el botón existe
    var backButton = $(".btn--back");
    if (backButton.length > 0) {
      // Cambiar la URL del botón
      backButton.attr("href", "/pages/alveo");
    }
  }


  // Country select
  $('.js-country-select').countrySelect({
    defaultCountry: "us",
    responsiveDropdown: true
  });

   // Establecer el nombre completo del país por defecto al cargar la página
   var defaultCountryData = $('.js-country-select').countrySelect('getSelectedCountryData');
   $('#country_code').val(defaultCountryData.name);

   $('.js-country-select').on('change', function() {
     var countryData = $(this).countrySelect('getSelectedCountryData');
     $('#country_code').val(countryData.name);  // Asigna el nombre completo del país
   });

  // Contact validation
   // Common class or attribute for all required fields
   var requiredFields = '#ContactForm input[required], #ContactForm textarea[required]';

   function checkFields() {
       var allFilled = true;
       $(requiredFields).each(function() {
           if (this.type === 'checkbox' && !this.checked) {
               allFilled = false; // If any checkbox is not checked
               return false; // Exit loop
           } else if ((this.type === 'text' || this.type === 'email' || this.tagName.toLowerCase() === 'textarea') && $(this).val().trim() === '') {
               allFilled = false; // If any text or email input is empty
               return false; // Exit loop
           }
       });
       return allFilled;
   }

   $(requiredFields).on('change keyup', function() {
       $('#ContactForm #contact-submit').prop('disabled', !checkFields());
   });

   // Función que se ejecuta cada vez que cambia el valor del select
   $('#contact-type').change(function() {
    // Verificar si el valor seleccionado es 'quotation'
    if ($(this).val() == 'quotation') {
        // Mostrar el div
        $('#quote-products').removeClass('hidden');
    } else {
        // Ocultar el div si se selecciona otra opción
        $('#quote-products').addClass('hidden');
    }
});


  // Contact validation
   // Common class or attribute for all required fields
   var requiredFields = '#flowLab input[required], #flowLab textarea[required]';

   function checkFields() {
       var allFilled = true;
       $(requiredFields).each(function() {
           if (this.type === 'checkbox' && !this.checked) {
               allFilled = false; // If any checkbox is not checked
               return false; // Exit loop
           } else if ((this.type === 'text' || this.type === 'email' || this.tagName.toLowerCase() === 'textarea') && $(this).val().trim() === '') {
               allFilled = false; // If any text or email input is empty
               return false; // Exit loop
           }
       });
       return allFilled;
   }

   $(requiredFields).on('change keyup', function() {
       $('#flowLab #contact-submit').prop('disabled', !checkFields());
   });


  // Función para capitalizar la primera letra
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

// Aplicar la función a los campos FirstName y LastName cuando pierden el foco
  $('#FirstName, #LastName').on('blur', function() {
      $(this).val(capitalizeFirstLetter($(this).val()));
      console.log($(this).val(capitalizeFirstLetter($(this).val())))
  });

   // Common class or attribute for all required fields
   var requiredFields = '#create_customer input.required-field';

    function checkFields() {
        var allFilled = true;
        $(requiredFields).each(function() {
            if ((this.type === 'text' || this.type === 'password' || this.type === 'email') && $(this).val().trim() === '') {
                allFilled = false; // Si algún input de text, password o email está vacío
                return false; // Salir del bucle
            }
        });
        return allFilled;
    }

    // Verificar los campos al cargar la página y en cada cambio
    $(requiredFields).on('change keyup', function() {
        $('#create_customer button[type="submit"]').prop('disabled', !checkFields());
    }).trigger('change'); // Esto activará el evento change al cargar la página


    // Overview & explore info
    $('.js-explore-grid').insertBefore('.container-product-info')
    setTimeout(function(){
      $('.js-overview-info').insertBefore('.container-product-info')
    }, 300);
    $('.product-info-elements').insertBefore('.js-explore-grid');


    // Sort collections
    $('#sort-by-collection').on('change', function() {
      var url = $(this).val(); // Obtener la URL de la opción seleccionada
      if(url) { // Verificar si la URL no está vacía
          window.location = url; // Redirigir al usuario a la URL seleccionada
      }
      return false;
  });

  // Suscribe url
  /*if($('form#flowLab').length > 0) {

    if (
      window.location.href.indexOf('?contact_posted=true#flowLab') !== -1 ||
      window.location.href.indexOf('?contact_posted=true') !== -1 
    ) {

      $('.modal--download').addClass('active');
      $('#software').click();
      $('.js-clear').click(function(){
        var cleanUrl = window.location.href.split('?')[0];
        window.location.replace(cleanUrl); // Usar replace en lugar de href
      });
      
      /*var downloadUrl = $('.flowlab-url').val();
      if (downloadUrl) {
          // Crear un elemento temporal para descargar el archivo
          var $tempDownloadLink = $('<a>', {
              href: downloadUrl,
              download: 'download',
              target: '_blank'
          });
          
          $tempDownloadLink.get(0).click(); // Forzar el click para iniciar la descarga
  
          // Redirigir a la misma página pero sin el fragmento de la URL
          var cleanUrl = window.location.href.split('?')[0];
          window.location.replace(cleanUrl); // Usar replace en lugar de href
      }
    }
  }*/
  

  if(window.location.href.indexOf('?get_quote=true') !== -1) {
    $('.contact-form #contact-type').val('quotation');
    $('#quote-products').removeClass('hidden');
  }

  // Masonry
  if (!Shopify.designMode) {

    // Función para reorganizar elementos en el DOM
    function reorderElements() {
      // Si la pantalla es lo suficientemente pequeña (por ejemplo, móvil)
      if ($(window).width() <= 768) {
          // Iterar sobre cada par de elementos .text
          $('.text').each(function(index) {
              // Verificar si hay un elemento .image siguiente
              var nextImage = $(this).next('.image');
              if (nextImage.length) {
                  // Mover el elemento .image antes del elemento .text actual
                  $(this).before(nextImage);
              }
          });
      } else {
          // Si la pantalla es lo suficientemente grande (por ejemplo, escritorio)
          // Restaurar el orden original
          $('.grid-item').each(function(index) {
              // Insertar la imagen después del texto
              $(this).append($(this).find('.text'));
          });
      }
  }

  // Ejecutar la función cuando se carga la página y al cambiar el tamaño de la ventana
  reorderElements();
  $(window).resize(reorderElements);

    $('.grid-masonry').masonry({
      itemSelector: '.grid-item',
    });
  }


  // Card button length
  // Selecciona el div deseado por su ID, puedes cambiar "#miDiv" por el selector que necesites
  $(".product-addons__item .half-block__btn").each(function(){
    var $this = $(this);
  
    // Cuenta el número de elementos con la clase ".btn" dentro del div
    var btnCount = $this.find('.btn').length;
    
    // Comprueba si el número de botones es mayor que 2
    console.log(btnCount)
    if (btnCount == 2) {
        // Agrega la clase "active" al div
        $this.addClass('active');
    }
  })

  // Certified link
  $('.certified-button').each(function(){
    let $this = $(this);
    let $link = '<a href="' + $this.data('url') + '" target="_blank"></a>';
    $this.parents('.text-column-with-image-wrapper').append($link)
  });
  
  // Hide empty button
   $('.grid-vertical__content .half-block__btn').each(function() {
    if ($(this).text().trim().length === 0) {
        $(this).hide(); 
    }
});

  // Faq template
  if($('.faq--template').length > 0) {
    $('.js-open-accordeon').addClass('active');
    $('.product-section-accordeon__text').slideUp('fast')
  }
  
  // PDF Files
  $('a').each(function() {
    var href = $(this).attr('href');
    if (href && (href.match(/\.pdf($|\?)/i) || href.match(/\.zip($|\?)/i))) {
        $(this).attr('target', '_blank');
    }
  });

  // FADE FAQ
  setTimeout(function() {
    $('.faq--layout').addClass('active');
    $('.loader-container').addClass('active');
  }, 1000);

  // Menu options padding
  let menuPadding = $('#menu-options').val();
  console.log(menuPadding)
  $('.middle-header-wrapper .site-nav > li > a').css({
    'padding-left': menuPadding + 'px',
    'padding-right': menuPadding + 'px'
  }); 

  // Fix css
  setTimeout(function() {
    $('#tidio-chat').removeAttr('style');
  }, 1000);
  

  
};

$(document).ready(DOMfunction);
